import './assets/styles/transfer.scss'

import avatar from './assets/images/agent-avatar.svg?url'
import assets from 'assets'

function action (event, widget, params) {

  var title = widget._header.find('.wgt-header-info h1')
  var button = widget._header.find('button[data-action="refresh"]')
  var salir = button.attr('title', 'Salir')
  var headerAvatar = widget._header.find('.wgt-header-info img')
  var controlSend = widget._controls.find('button svg circle')

  switch (params.to) {
    case 'agent':
      headerAvatar.attr('src', avatar)
      widget._header.addClass('agent')
      controlSend.addClass('agent')
      title.text('Ejecutivo')
      salir.show().one('click', function (event) {
        title.text(widget.option('assistant.name'))
        widget._header.find('.wgt-header-info img').attr('src', assets.images['avatar'])
        widget._header.removeClass('agent')
        controlSend.removeClass('agent')
        salir.hide()
      })
      break
    // to claudia
    default:
      // old
      // title.text(widget.option('assistant.name'))
      // widget._header.attr('src', assets.images['avatar'])
      // salir.hide()
      title.text(widget.option('assistant.name'))
      widget._header.find('.wgt-header-info img').attr('src', assets.images['avatar'])
      widget._header.removeClass('agent')
      controlSend.removeClass('agent')
      //if (params.to !== 'claudia-reset'){
      //  widget._send({
      //    type: 'text',
      //    payload: 'retomar_conversacion'
      //  }, true)
      //}   
      salir.hide()
      break
  }
}

export default action
